<template>
  <div class="layout-root">
    <v-app-bar app flat class="app-bar" elevation="0">
      <v-app-bar-nav-icon class="mobile-menu-btn" @click="drawer = !drawer" />
      
      <div class="brand" aria-label="Herrametal">
        <img class="brand-logo" :src="brandLogo" alt="Herrametal" />
      </div>

      <div class="nav desktop-nav">
        <v-btn
          v-if="!isCounterOperator"
          text 
          class="nav-link home-link" 
          :class="{ active: isActive('/') }" 
          :to="{ name: 'home' }"
        >
          <v-icon size="18">mdi-home-outline</v-icon>
        </v-btn>
        
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="nav-link" :class="{ active: isMenuActive('sales') }" v-bind="attrs" v-on="on">
              Ventas
              <v-icon right size="18">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="nav-menu">
            <v-list-item :to="{ name: 'sales-catalog' }">
              <v-list-item-icon><v-icon size="18">mdi-currency-usd</v-icon></v-list-item-icon>
              <v-list-item-title>Mostrador</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canViewBudgets" :to="{ name: 'sales-budgets' }">
              <v-list-item-icon><v-icon size="18">mdi-file-document-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Presupuestos</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canViewBudgets" :to="{ name: 'sales-orders' }">
              <v-list-item-icon><v-icon size="18">mdi-clipboard-list-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Mis pedidos</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canManageCommercialOrders" :to="{ name: 'sales-order-management' }">
              <v-list-item-icon><v-icon size="18">mdi-clipboard-check-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Gestión de pedidos</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canManageCommercialOrders" :to="{ name: 'sales-approvals' }">
              <v-list-item-icon><v-icon size="18">mdi-shield-check-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Créditos y autorizaciones</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canViewCashier" :to="{ name: 'sales-counter-invoices' }">
              <v-list-item-icon><v-icon size="18">mdi-cash-register</v-icon></v-list-item-icon>
              <v-list-item-title>Caja / Facturación</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canViewCurrentAccountBilling" :to="{ name: 'sales-current-account-invoices' }">
              <v-list-item-icon><v-icon size="18">mdi-file-account-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Facturación de Cuenta Corriente</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canViewSalesAccounts" :to="{ name: 'sales-current-accounts' }">
              <v-list-item-icon><v-icon size="18">mdi-account-cash-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Clientes y Cuentas</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canViewSalesAccounts" :to="{ name: 'sales-collections' }">
              <v-list-item-icon><v-icon size="18">mdi-hand-coin-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Cobranzas</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canViewSalesReports" :to="{ name: 'sales-reports' }">
              <v-list-item-icon><v-icon size="18">mdi-chart-areaspline</v-icon></v-list-item-icon>
              <v-list-item-title>Reportes Comerciales</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canManageCommissions" :to="{ name: 'sales-commissions' }">
              <v-list-item-icon><v-icon size="18">mdi-percent-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Comisiones</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canConfigureCommercial" :to="{ name: 'sales-commercial-config' }">
              <v-list-item-icon><v-icon size="18">mdi-account-tie-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Vendedores / Corredores</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>


        <v-menu v-if="canViewPurchases" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="nav-link" :class="{ active: isMenuActive('purchases') }" v-bind="attrs" v-on="on">
              Compras
              <v-icon right size="18">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="nav-menu">
            <v-list-item :to="{ name: 'purchases-management' }">
              <v-list-item-icon><v-icon size="18">mdi-truck-delivery-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Gestión de compras</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'purchases-suppliers' }">
              <v-list-item-icon><v-icon size="18">mdi-account-cash-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Proveedores y Cuentas</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'internal-orders-dashboard' }" v-if="hasPermission('internal_orders.manage')" @click="drawer = false">
              <v-list-item-icon><v-icon size="18">mdi-cart-arrow-down</v-icon></v-list-item-icon>
              <v-list-item-title>Pedidos Pendientes</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'internal-orders-list' }" v-if="hasPermission('internal_orders.read')" @click="drawer = false">
              <v-list-item-icon><v-icon size="18">mdi-clipboard-text-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Pedidos Internos</v-list-item-title>
            </v-list-item>

          </v-list>
        </v-menu>

        <v-menu v-if="canViewStock" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="nav-link" :class="{ active: isMenuActive('stock') }" v-bind="attrs" v-on="on">
              Inventario
              <v-icon right size="18">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="nav-menu">
            <v-list-item :to="{ name: 'stock-catalog' }">
              <v-list-item-icon><v-icon size="18">mdi-file-tree-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Catálogo de Productos</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'stock-inventory' }">
              <v-list-item-icon><v-icon size="18">mdi-format-list-bulleted</v-icon></v-list-item-icon>
              <v-list-item-title>Ajustes de Stock</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu v-if="isAdmin" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="nav-link" :class="{ active: isMenuActive('pricing') }" v-bind="attrs" v-on="on">
              Precios
              <v-icon right size="18">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="nav-menu">
            <v-list-item :to="{ name: 'pricing-management' }">
              <v-list-item-icon><v-icon size="18">mdi-pencil-ruler</v-icon></v-list-item-icon>
              <v-list-item-title>Gestión de precios</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'stock-price-list' }">
              <v-list-item-icon><v-icon size="18">mdi-format-list-bulleted</v-icon></v-list-item-icon>
              <v-list-item-title>Administración de listas</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'pricing-dashboard' }">
              <v-list-item-icon><v-icon size="18">mdi-chart-line</v-icon></v-list-item-icon>
              <v-list-item-title>Panel de márgenes</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'pricing-bonuses' }">
              <v-list-item-icon><v-icon size="18">mdi-sale</v-icon></v-list-item-icon>
              <v-list-item-title>Descuentos adicionales</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu v-if="isAdmin" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="nav-link" :class="{ active: isMenuActive('config') }" v-bind="attrs" v-on="on">
              Configuración
              <v-icon right size="18">mdi-cog-outline</v-icon>
            </v-btn>
          </template>
          <v-list dense class="nav-menu">
            <v-list-item :to="{ name: 'security-users' }">
              <v-list-item-icon><v-icon size="18">mdi-account-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Usuarios</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'security-roles' }">
              <v-list-item-icon><v-icon size="18">mdi-shield-key-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Roles y Permisos</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'config-afip' }">
              <v-list-item-icon><v-icon size="18">mdi-shield-check-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Módulo Fiscal (AFIP)</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'config-remito-templates' }">
              <v-list-item-icon><v-icon size="18">mdi-palette-swatch-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Configuración de Remitos</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'email-config' }">
              <v-list-item-icon><v-icon size="18">mdi-email-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Configuración de Correos</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'config-iibb' }">
              <v-list-item-icon><v-icon size="18">mdi-file-percent-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Padrones de IIBB</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'config-points-of-sale' }">
              <v-list-item-icon><v-icon size="18">mdi-store</v-icon></v-list-item-icon>
              <v-list-item-title>Puntos de Venta</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'config-afip' }">
              <v-list-item-icon><v-icon size="18">mdi-certificate</v-icon></v-list-item-icon>
              <v-list-item-title>Certificados AFIP</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'config-webhooks' }">
              <v-list-item-icon><v-icon size="18">mdi-webhook</v-icon></v-list-item-icon>
              <v-list-item-title>Webhooks</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'security-audit' }">
              <v-list-item-icon><v-icon size="18">mdi-clipboard-text-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Auditoría de Sistema</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu v-if="canViewAccounting" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="nav-link" :class="{ active: isMenuActive('accounting') || isMenuActive('ops') }" v-bind="attrs" v-on="on">
              Contabilidad
              <v-icon right size="18">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="nav-menu">
            <v-list-item :to="{ name: 'accounting-periods' }">
              <v-list-item-icon><v-icon size="18">mdi-calendar-check-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Períodos</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'accounting-reconciliation' }">
              <v-list-item-icon><v-icon size="18">mdi-source-merge</v-icon></v-list-item-icon>
              <v-list-item-title>Conciliación</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'accounting-reports' }">
              <v-list-item-icon><v-icon size="18">mdi-finance</v-icon></v-list-item-icon>
              <v-list-item-title>Reportes</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'treasury' }">
              <v-list-item-icon><v-icon size="18">mdi-bank-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Tesorería</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'ops-monitoring' }">
              <v-list-item-icon><v-icon size="18">mdi-pulse</v-icon></v-list-item-icon>
              <v-list-item-title>Operaciones</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-spacer />

      <div class="actions">
        <button
          type="button"
          class="theme-toggle"
          :class="{ active: isDark }"
          @click="toggleTheme"
          :title="isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'"
          :aria-label="isDark ? 'Activar tema claro' : 'Activar tema oscuro'"
        >
          <span class="theme-toggle-knob">
            <img
              class="theme-toggle-icon"
              :src="isDark ? sunIcon : moonIcon"
              :alt="isDark ? 'Modo claro' : 'Modo oscuro'"
            />
          </span>
        </button>
        <div class="user-divider"></div>
        <v-btn text class="user-chip" v-if="userName">
          <v-avatar size="32" class="user-avatar">
            <span>{{ initials }}</span>
          </v-avatar>
          <span class="user-name">{{ userName }}</span>
        </v-btn>
        <v-btn 
          outlined 
          color="error" 
          class="logout-btn" 
          @click="handleLogout"
        >
          Salir
        </v-btn>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      class="mobile-drawer"
    >
      <v-list>
        <v-list-item v-if="!isCounterOperator" :to="{ name: 'home' }" @click="drawer = false">
          <v-list-item-icon>
            <v-icon>mdi-home-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item>

        <v-list-group prepend-icon="mdi-cash-multiple">
          <template v-slot:activator>
            <v-list-item-title>Ventas</v-list-item-title>
          </template>
          <v-list-item :to="{ name: 'sales-catalog' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-currency-usd</v-icon></v-list-item-icon>
            <v-list-item-title>Mostrador</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="canViewBudgets" :to="{ name: 'sales-budgets' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-file-document-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Presupuestos</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="canViewBudgets" :to="{ name: 'sales-orders' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-clipboard-list-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Mis pedidos</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="canManageCommercialOrders" :to="{ name: 'sales-order-management' }" @click="drawer = false"><v-list-item-icon><v-icon size="18">mdi-clipboard-check-outline</v-icon></v-list-item-icon><v-list-item-title>Gestión de pedidos</v-list-item-title></v-list-item>
          <v-list-item v-if="canManageCommercialOrders" :to="{ name: 'sales-approvals' }" @click="drawer = false"><v-list-item-icon><v-icon size="18">mdi-shield-check-outline</v-icon></v-list-item-icon><v-list-item-title>Créditos y autorizaciones</v-list-item-title></v-list-item>
          <v-list-item v-if="canViewCashier" :to="{ name: 'sales-counter-invoices' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-cash-register</v-icon></v-list-item-icon>
            <v-list-item-title>Caja / Facturación</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="canViewCurrentAccountBilling" :to="{ name: 'sales-current-account-invoices' }" @click="drawer = false"><v-list-item-icon><v-icon size="18">mdi-file-account-outline</v-icon></v-list-item-icon><v-list-item-title>Facturación de Cuenta Corriente</v-list-item-title></v-list-item>
          <v-list-item v-if="canViewSalesAccounts" :to="{ name: 'sales-current-accounts' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-account-cash-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Clientes y Cuentas</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="canViewSalesAccounts" :to="{ name: 'sales-collections' }" @click="drawer = false"><v-list-item-icon><v-icon size="18">mdi-hand-coin-outline</v-icon></v-list-item-icon><v-list-item-title>Cobranzas</v-list-item-title></v-list-item>
          <v-list-item v-if="canManageCommissions" :to="{ name: 'sales-commissions' }" @click="drawer = false"><v-list-item-icon><v-icon size="18">mdi-percent-outline</v-icon></v-list-item-icon><v-list-item-title>Comisiones</v-list-item-title></v-list-item>
          <v-list-item v-if="canConfigureCommercial" :to="{ name: 'sales-commercial-config' }" @click="drawer = false"><v-list-item-icon><v-icon size="18">mdi-account-tie-outline</v-icon></v-list-item-icon><v-list-item-title>Vendedores / Corredores</v-list-item-title></v-list-item>
        </v-list-group>

        <v-list-group v-if="canViewPurchases" prepend-icon="mdi-cart-outline">
          <template v-slot:activator>
            <v-list-item-title>Compras</v-list-item-title>
          </template>
          <v-list-item :to="{ name: 'purchases-management' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-truck-delivery-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Gestión de compras</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'purchases-suppliers' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-account-cash-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Proveedores y Cuentas</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'internal-orders-dashboard' }" v-if="hasPermission('internal_orders.manage')" @click="drawer = false">
            <v-list-item-icon><v-icon>mdi-cart-arrow-down</v-icon></v-list-item-icon>
            <v-list-item-title>Pedidos Pendientes</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'internal-orders-list' }" v-if="hasPermission('internal_orders.read')" @click="drawer = false">
            <v-list-item-icon><v-icon>mdi-clipboard-text-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Pedidos Internos</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group v-if="canViewAccounting" prepend-icon="mdi-calculator-variant-outline">
          <template v-slot:activator>
            <v-list-item-title>Contabilidad</v-list-item-title>
          </template>
          <v-list-item :to="{ name: 'accounting-periods' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-calendar-check-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Períodos</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'accounting-reconciliation' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-source-merge</v-icon></v-list-item-icon>
            <v-list-item-title>Conciliación</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'accounting-reports' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-finance</v-icon></v-list-item-icon>
            <v-list-item-title>Reportes</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'ops-monitoring' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-pulse</v-icon></v-list-item-icon>
            <v-list-item-title>Operaciones</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group v-if="canViewStock" prepend-icon="mdi-warehouse">
          <template v-slot:activator>
            <v-list-item-title>Inventario</v-list-item-title>
          </template>
          <v-list-item :to="{ name: 'stock-catalog' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-file-tree-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Catálogo de productos</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'stock-inventory' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-format-list-bulleted</v-icon></v-list-item-icon>
            <v-list-item-title>Ajustes de stock</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group v-if="isAdmin" prepend-icon="mdi-tag-multiple-outline">
          <template v-slot:activator>
            <v-list-item-title>Precios</v-list-item-title>
          </template>
          <v-list-item :to="{ name: 'pricing-management' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-pencil-ruler</v-icon></v-list-item-icon>
            <v-list-item-title>Gestión de precios</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'stock-price-list' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-format-list-bulleted</v-icon></v-list-item-icon>
            <v-list-item-title>Administración de listas</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'pricing-dashboard' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-chart-line</v-icon></v-list-item-icon>
            <v-list-item-title>Panel de márgenes</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'pricing-bonuses' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-sale</v-icon></v-list-item-icon>
            <v-list-item-title>Descuentos adicionales</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group v-if="isAdmin" prepend-icon="mdi-cog-outline">
          <template v-slot:activator>
            <v-list-item-title>Configuración</v-list-item-title>
          </template>
          <v-list-item :to="{ name: 'security-users' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-account-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Usuarios</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'security-roles' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-shield-key-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Roles y Permisos</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'config-afip' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-shield-check-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Módulo Fiscal (AFIP)</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'email-config' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-email-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Configuración de Correos</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'config-iibb' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-file-percent-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Padrones de IIBB</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'config-points-of-sale' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-store</v-icon></v-list-item-icon>
            <v-list-item-title>Puntos de Venta</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'config-afip' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-certificate</v-icon></v-list-item-icon>
            <v-list-item-title>Certificados AFIP</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'config-webhooks' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-webhook</v-icon></v-list-item-icon>
            <v-list-item-title>Webhooks</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'security-audit' }" @click="drawer = false">
            <v-list-item-icon><v-icon size="18">mdi-clipboard-text-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Auditoría</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-main class="app-main">
      <router-view />
    </v-main>

    <v-snackbar
      v-model="snackbarShow"
      :timeout="notification.timeout"
      top
      right
      :class="[`premium-toast`, `premium-toast--${notification.type}`]"
      content-class="white--text font-weight-bold"
    >
      <div class="d-flex align-center">
        <v-icon color="white" class="mr-3">{{ notificationIcon }}</v-icon>
        {{ notification.text }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="$store.commit('ui/HIDE_NOTIFICATION')">
          <v-icon color="white" small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import sunIcon from "@/assets/theme-sun.svg";
import moonIcon from "@/assets/theme-moon.svg";
import brandLogo from "@/assets/brand/herrametal-logo-blue.png";
import { hasPermission as userHasPermission, hasAnyPermission, hasAnyRole, normalizePermissionCodes } from "@/utils/access";

export default {
  name: "MainLayout",
  data() {
    return {
      drawer: false,
      isDark: false,
      sunIcon,
      moonIcon,
      brandLogo,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    notification() {
      return this.$store.state.ui.notification;
    },
    snackbarShow: {
      get() {
        return this.notification.show;
      },
      set(val) {
        if (!val) {
          this.$store.commit("ui/HIDE_NOTIFICATION");
        }
      }
    },
    notificationIcon() {
      const icons = {
        success: "mdi-check-circle-outline",
        error: "mdi-alert-circle-outline",
        info: "mdi-information-outline",
        warning: "mdi-alert-outline",
      };
      return icons[this.notification.type] || icons.info;
    },
    roles() {
      return (this.user && this.user.roles) || [];
    },
    permissions() {
      return normalizePermissionCodes(this.user?.permissions);
    },
    isAdmin() {
      return hasAnyRole(this.user, ["admin"]);
    },
    normalizedRoles() {
      return (Array.isArray(this.roles) ? this.roles : [])
        .map((x) => String(x || "").trim().toLowerCase());
    },
    isCounterOperator() {
      return this.normalizedRoles.includes("operario_mostrador")
        || this.normalizedRoles.includes("operario mostrador")
        || this.normalizedRoles.includes("mostrador");
    },
    canViewStock() {
      if (this.isCounterOperator) return false;
      if (this.isAdmin) return true;
      return hasAnyRole(this.user, ["stock", "deposito", "almacen"]);
    },
    canViewSecurity() {
      if (this.isCounterOperator) return false;
      if (this.isAdmin) return true;
      const roles = Array.isArray(this.roles) ? this.roles : [];
      return roles.includes("security") || roles.includes("seguridad");
    },
    canViewAccounting() {
      if (this.isCounterOperator) return false;
      if (this.isAdmin) return true;
      return hasAnyRole(this.user, ["security", "seguridad", "contabilidad", "accounting"])
        || hasAnyPermission(this.user, ["accounting.period.view", "accounting.reconcile.view", "accounting.report.view"]);
    },
    canViewSalesAccounts() {
      if (this.isCounterOperator) return false;
      if (this.isAdmin) return true;
      return this.hasPermission("sales.current_accounts.view");
    },
    canViewBudgets() {
      return this.isAdmin || hasAnyPermission(this.user, ["sales.budget.read", "sales.budget.create"]);
    },
    canViewCashier() {
      if (this.isCounterOperator) return false;
      return this.isAdmin || hasAnyPermission(this.user, ["sales.order.process_sale", "sales.invoice.read"]);
    },
    canViewCurrentAccountBilling() {
      if (this.isCounterOperator) return false;
      return this.isAdmin || hasAnyPermission(this.user, ["sales.current_account_invoice.read", "sales.current_account_invoice.issue"]);
    },
    canManageCommercialOrders() {
      if (this.isCounterOperator) return false;
      return this.isAdmin || hasAnyPermission(this.user, ["sales.order.review", "sales.credit.approve", "sales.discount.approve", "sales.preparation.manage"]);
    },
    canManageCommissions() {
      if (this.isCounterOperator) return false;
      return this.isAdmin || hasAnyPermission(this.user, ["sales.commission.manage", "sales.commission.read_own"]);
    },
    canConfigureCommercial() {
      if (this.isCounterOperator) return false;
      return this.isAdmin || hasAnyPermission(this.user, ["sales.commercial_config.manage", "sales.agent.manage"]);
    },
    canViewSalesReports() {
      if (this.isCounterOperator) return false;
      if (this.isAdmin) return true;
      return hasAnyPermission(this.user, ["reports.view"]);
    },
    canViewPurchases() {
      if (this.isCounterOperator) return false;
      if (this.isAdmin) return true;
      return hasAnyPermission(this.user, [
        "purchases.read",
        "purchases.create",
        "purchases.confirm",
        "purchases.receive",
        "internal_orders.read",
        "internal_orders.manage",
      ]);
    },
    userName() {
      return (this.user && this.user.username) || "";
    },
    initials() {
      const name = this.userName.trim();
      return name ? name[0].toUpperCase() : "A";
    },
  },
  mounted() {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") {
      this.isDark = true;
      document.documentElement.setAttribute("data-theme", "dark");
      return;
    }

    if (!savedTheme && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
      this.isDark = true;
      document.documentElement.setAttribute("data-theme", "dark");
    }
  },
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
    isMenuActive(section) {
      const path = this.$route.path;
      return path.includes(`/${section}`);
    },
    toggleTheme() {
      this.isDark = !this.isDark;
      if (this.isDark) {
        document.documentElement.setAttribute("data-theme", "dark");
        localStorage.setItem("theme", "dark");
      } else {
        document.documentElement.removeAttribute("data-theme");
        localStorage.setItem("theme", "light");
      }
    },
    async handleLogout() {
      await this.$store.dispatch("auth/logout");
      this.$router.push({ name: "login" });
    },
    hasPermission(code) {
      return userHasPermission(this.user, code);
    },
  },
};
</script>

<style scoped>
.layout-root {
  min-height: 100vh;
  font-family: "Poppins", "Segoe UI", system-ui, sans-serif;
  /* Paleta ERP Corporativa */
  --erp-primary-dark: #1E3A8A;
  --erp-primary-action: #2563EB;
  --erp-sidebar-bg: #F1F5F9;
  --erp-content-bg: #FFFFFF;
  --erp-success: #166534;
  --erp-warning: #854D0E;
  --erp-danger: #991B1B;
  --erp-neutral: #64748B;
  --erp-text-light: #F8FAFC;
  --erp-text-muted: #94A3B8;
  /* Componentes */
  --topbar-border-soft: rgba(255, 255, 255, 0.15);
  --topbar-border-strong: rgba(255, 255, 255, 0.25);
  --toggle-bg: rgba(255, 255, 255, 0.1);
  --toggle-border: rgba(255, 255, 255, 0.25);
  --toggle-text: #F1F5F9;
  --toggle-hover-bg: rgba(37, 99, 235, 0.3);
  --toggle-hover-border: rgba(96, 165, 250, 0.6);
}

.app-bar {
  background: var(--erp-primary-dark) !important;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0 !important;
  margin: 0;
  width: 100% !important;
  left: 0 !important;
  padding: 0 24px;
  box-shadow: 0 4px 20px rgba(30, 58, 138, 0.25), 0 1px 3px rgba(0, 0, 0, 0.1);
}

.app-bar.v-sheet,
.app-bar.v-toolbar {
  border-radius: 0 !important;
}

.app-bar .v-toolbar__content {
  color: var(--erp-text-light);
  min-height: 60px;
}

.mobile-menu-btn {
  display: none;
}

.brand {
  display: flex;
  align-items: center;
}

.brand-logo {
  display: block;
  width: 176px;
  height: auto;
  max-height: 42px;
  object-fit: contain;
  object-position: left center;
}

.nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 28px;
}

.desktop-nav {
  display: flex;
}

.nav-link {
  text-transform: none;
  font-weight: 500;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85) !important;
  letter-spacing: 0.01em;
  padding: 6px 14px !important;
  border-radius: 6px;
  min-height: 34px;
  transition: all 0.15s ease;
}

.nav-link .v-icon {
  color: rgba(255, 255, 255, 0.7) !important;
  transition: color 0.15s ease;
}

.nav-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF !important;
}

.nav-link:hover .v-icon {
  color: #FFFFFF !important;
}

.home-link {
  min-width: 38px;
  padding: 0 10px !important;
}

.nav-link.active {
  color: #FFFFFF !important;
  background: var(--erp-primary-action);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  font-weight: 600;
}

.nav-link.active .v-icon {
  color: #FFFFFF !important;
}

.nav-menu {
  min-width: 220px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  margin-top: 4px;
}

::v-deep .v-menu__content .nav-menu .v-list-item__title,
::v-deep .v-menu__content .nav-menu .v-icon {
  color: #0f172a !important;
}

html[data-theme="dark"] ::v-deep .v-menu__content .nav-menu {
  background: linear-gradient(160deg, #16243f 0%, #101b31 100%) !important;
  border: 1px solid rgba(148, 163, 184, 0.26);
  box-shadow: 0 14px 26px rgba(2, 6, 23, 0.44);
}

html[data-theme="dark"] ::v-deep .v-menu__content .nav-menu .v-list-item {
  min-height: 40px;
}

html[data-theme="dark"] ::v-deep .v-menu__content .nav-menu .v-list-item__title,
html[data-theme="dark"] ::v-deep .v-menu__content .nav-menu .v-icon {
  color: #dbeafe !important;
}

html[data-theme="dark"] ::v-deep .v-menu__content .nav-menu .v-list-item__icon,
html[data-theme="dark"] ::v-deep .v-menu__content .nav-menu .v-list-item__icon .v-icon,
::v-deep html[data-theme="dark"] .v-menu__content .nav-menu .v-list-item__icon,
::v-deep html[data-theme="dark"] .v-menu__content .nav-menu .v-list-item__icon .v-icon {
  color: #dbeafe !important;
  opacity: 1 !important;
}

html[data-theme="dark"] ::v-deep .v-menu__content .nav-menu .v-list-item:hover {
  background: rgba(59, 130, 246, 0.16);
}

.actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.theme-toggle {
  position: relative;
  width: 64px;
  height: 32px;
  padding: 0;
  border: 0;
  cursor: pointer;
  color: var(--toggle-text);
  border: 1px solid var(--toggle-border);
  border-radius: 999px;
  background: var(--toggle-bg);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  overflow: hidden;
}

.theme-toggle::before,
.theme-toggle::after {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 11px;
  opacity: 0.5;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.theme-toggle::before {
  content: "☀";
  left: 8px;
}

.theme-toggle::after {
  content: "☾";
  right: 8px;
}

.theme-toggle-knob {
  position: absolute;
  top: 2px;
  left: 3px;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  color: var(--erp-primary-dark);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.theme-toggle-icon {
  width: 14px;
  height: 14px;
  display: block;
  transition: transform 0.2s ease;
}

.theme-toggle.active .theme-toggle-knob {
  transform: translateX(30px);
  background: #F1F5F9;
  color: #1E3A8A;
}

.theme-toggle.active::before {
  opacity: 0.28;
}

.theme-toggle.active::after {
  opacity: 0.85;
}

.theme-toggle:hover {
  border-color: var(--toggle-hover-border);
  background: var(--toggle-hover-bg);
}

.theme-toggle:hover .theme-toggle-icon {
  transform: rotate(-8deg);
}

.user-divider {
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.15);
}

.user-chip {
  text-transform: none;
  padding: 5px 12px !important;
  border-radius: 6px;
  transition: all 0.15s ease;
  color: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.08);
}

.user-chip:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.25);
}

.user-avatar {
  background: var(--erp-primary-action);
  font-weight: 600;
  font-size: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.user-name {
  font-weight: 500;
  color: #FFFFFF;
  font-size: 13px;
}

.logout-btn {
  text-transform: none;
  font-weight: 600;
  font-size: 13px;
  border-radius: 6px;
  padding: 5px 14px !important;
  border-width: 1px !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.9) !important;
  background: rgba(0, 0, 0, 0.15);
  transition: all 0.15s ease;
}

.logout-btn:hover {
  background: var(--erp-danger) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  color: #FFFFFF !important;
}

html[data-theme="dark"] .nav-link {
  color: rgba(255, 255, 255, 0.85) !important;
}

html[data-theme="dark"] .nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
}

html[data-theme="dark"] .nav-link.active {
  background: var(--erp-primary-action);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.5);
}

html[data-theme="dark"] .theme-toggle,
html[data-theme="dark"] .user-chip {
  --toggle-bg: rgba(15, 23, 42, 0.4);
  --toggle-border: rgba(148, 163, 184, 0.4);
  --toggle-text: #e2e8f0;
  --toggle-hover-bg: rgba(59, 130, 246, 0.3);
  --toggle-hover-border: rgba(147, 197, 253, 0.6);
  border-color: rgba(148, 163, 184, 0.3);
  background: rgba(30, 41, 59, 0.4);
}

html[data-theme="dark"] .theme-toggle::before,
html[data-theme="dark"] .theme-toggle::after {
  color: #94A3B8;
}

html[data-theme="dark"] .theme-toggle-knob {
  background: #F1F5F9;
  color: #1E3A8A;
}

html[data-theme="dark"] .theme-toggle.active .theme-toggle-knob {
  background: #CBD5E1;
  color: #1E3A8A;
}

html[data-theme="dark"] .theme-toggle:hover,
html[data-theme="dark"] .user-chip:hover {
  border-color: rgba(96, 165, 250, 0.5);
  background: rgba(59, 130, 246, 0.25);
}

.app-main {
  background: var(--erp-sidebar-bg);
  padding: 24px;
  min-height: calc(100vh - 60px);
}

html[data-theme="dark"] .app-main {
  background: #0F172A;
}

.mobile-drawer {
  padding-top: 16px;
}

@media (max-width: 960px) {
  .mobile-menu-btn {
    display: flex;
  }
  
  .desktop-nav {
    display: none;
  }
  
  .app-bar {
    padding: 0 16px;
  }

  .theme-toggle,
  .user-chip,
  .logout-btn {
    border-radius: 10px;
  }
  
  .brand-logo {
    width: 142px;
    max-height: 34px;
  }
  
  .user-divider {
    display: none;
  }
  
  .user-name {
    display: none;
  }
  
  .logout-btn {
    min-width: auto !important;
    padding: 6px 10px !important;
  }
}
</style>
